import {
  GetProcessesToAssignDocument,
  GetProcessesToAssignQueryVariables,
  ProcessesProcess,
  ProcessesProcessCategoryEnum,
} from 'generated/resources/graphql'
import { ProcessDetailFragment } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useAssignableProcesses = (categories?: ProcessesProcessCategoryEnum[]) => {
  const { loading, processes, refetch } = useProcesses({ validate: true, categories })

  const filteredProcesses = () => {
    if (loading) return []

    return filterProcesses(processes as ProcessesProcess[]) // eslint-disable-line no-type-assertion/no-type-assertion
  }

  const handleFocus = () => {
    refetch()
  }

  useEffect(() => {
    window.addEventListener('focus', handleFocus)

    return () => {
      window.removeEventListener('focus', handleFocus)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const assignableProcesses = filteredProcesses()

  return {
    loading,
    processes: assignableProcesses,
    areAllAssignable: validProcesses(assignableProcesses),
  }
}

const filterProcesses = (processes: ProcessesProcess[]) =>
  processes.map((process) => ({
    ...process,
    disabled: !process.validSettings,
  }))

const validProcesses = (processes: ProcessesProcess[]) =>
  processes.some((process) => !process.validSettings)

export type Process = ProcessDetailFragment
export type Step = ProcessDetailFragment['steps'][number]
export type Item = Step['items'][number]

const useProcesses = (variables?: GetProcessesToAssignQueryVariables) => {
  const { data, loading, refetch } = useQuery(GetProcessesToAssignDocument, { variables })

  return {
    loading,
    refetch,
    processes: data ? (data.processes.processesConnection.nodes as Process[]) : [], // eslint-disable-line no-type-assertion/no-type-assertion
  }
}
